module.exports = __webpack_public_path__ + "img/icon-dapp-stake.21f5fa37.svg";